<template>
  <div class="table-wrapper">
    <table>
      <caption class="visually-hidden">
        {{
          $t('CLOSING_REASONS.TABLE.TOTAL_RESOLVED_CONVERSATIONS')
        }}
      </caption>
      <thead>
        <tr>
          <th></th>
          <th>{{ $t('CLOSING_REASONS.TABLE.RESOLVED_AT') }}</th>
          <th>{{ $t('CLOSING_REASONS.TABLE.RESOLVED_BY') }}</th>
          <th>{{ $t('CLOSING_REASONS.TABLE.CLOSING_REASON') }}</th>
          <th>{{ $t('CLOSING_REASONS.TABLE.COMMENT') }}</th>
          <th>{{ $t('CLOSING_REASONS.TABLE.PRODUCTS') }}</th>
          <th>{{ $t('CLOSING_REASONS.TABLE.LINK_TO_CONVERSATION') }}</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(item, index) in paginatedData"
          :key="item.id"
          :class="{ 'striped-row': index % 2 !== 0 }"
        >
          <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>

          <td>{{ formatDate(item.created_at) }}</td>

          <td>
            {{
              item.resolved_by && item.resolved_by.name
                ? item.resolved_by.name
                : '-'
            }}
          </td>

          <td>
            {{
              item.closing_reason &&
              item.closing_reason.name &&
              item.closing_reason.name.name
                ? item.closing_reason.name.name
                : '-'
            }}
          </td>

          <td>{{ item.comments_fallback || '-' }}</td>

          <td>
            <div
              v-if="item.products && item.products.length"
              class="products-wrap"
            >
              <span
                v-for="product in item.products"
                :key="product"
                class="product-badge"
              >
                {{ product }}
              </span>
            </div>

            <span v-else>-</span>
          </td>

          <td>
            <a :href="baseUrl + item.display_id" target="_blank">
              {{ baseUrl + item.display_id }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pagination">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        {{ $t('CLOSING_REASONS.PAGINATION.PREVIOUS') }}
      </button>

      <span>
        {{ $t('CLOSING_REASONS.PAGINATION.PAGE') }} {{ currentPage }}
        {{ $t('CLOSING_REASONS.COMMON.OF') }} {{ totalPages }}
      </span>

      <button
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        {{ $t('CLOSING_REASONS.PAGINATION.NEXT') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClosingReasonsTable',
  props: {
    reasonsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 100,
    };
  },
  computed: {
    sortedData() {
      return [...this.reasonsData].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;

      return this.sortedData.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.reasonsData.length / this.perPage);
    },
    accountId() {
      const match = window.location.pathname.match(/\/accounts\/(\d+)/);

      return match ? match[1] : null;
    },
    baseUrl() {
      return (
        window.location.origin +
        '/app/accounts/' +
        this.accountId +
        '/conversations/'
      );
    },
  },
  methods: {
    formatDate(dateString) {
      return new Date(dateString).toLocaleString('pt-BR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}

thead {
  background-color: #2563eb;
  color: white;
}

th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  word-break: break-word;
  vertical-align: top;
}

.striped-row {
  background-color: #f9f9f9;
}

a {
  color: #2563eb;
  text-decoration: underline;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

.pagination button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

th:first-child,
td:first-child {
  text-align: right;
  width: 40px;
  color: #555;
  white-space: nowrap;
}

.products-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.product-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}
</style>
